/**
 * @generated SignedSource<<6c8877204e47e51f2fa2a48d1d8384df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleSpeechPlayerArticle$data = {
  readonly entityId: string;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsPostiesArticle" | "hooksBuildSpeechifyConfigArticle">;
  readonly " $fragmentType": "articleSpeechPlayerArticle";
};
export type articleSpeechPlayerArticle$key = {
  readonly " $data"?: articleSpeechPlayerArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleSpeechPlayerArticle">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleSpeechPlayerArticle",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersCheckIsPostiesArticle",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SectionSegment",
          "kind": "LinkedField",
          "name": "sections",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Section",
              "kind": "LinkedField",
              "name": "value",
              "plural": true,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksBuildSpeechifyConfigArticle"
    },
    (v0/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "05b0fcf6157236a104ad0fa66d84e2ea";

export default node;
